module.exports = __webpack_public_path__ + "media/images/orbit/right-arrow-half-size-da380a0319381f6faa98e25612dd1b4ce8db05e6548330c0740c4e0a633b395d.png";